import Tile from '../layout/Tile'
import { Skeleton, Typography } from '@mui/material'
import { ITimeSettings } from '../../definitions/Shared'
import RouteIcon, { IconName } from '../routing/RouteIcon'
import TimeSelection from './TimeSelection'
import { ReactElement } from 'react'

interface P {
    primary: string
    secondary?: string
    timeSettings?: ITimeSettings
    isLoading?: boolean
    subActions?: {
        label: string
        icon: IconName
        onClick?: () => void
    }[]
    actions?: ReactElement
}

function RouteHeader({ primary, secondary, timeSettings, subActions, actions, isLoading }: P) {
    return (
        <Tile.Column flex={0}>
            <Tile.Row flex={0} spacing={1}>
                <Tile.Row alignItems='center'>
                    {isLoading
                        ? <Skeleton variant='text' sx={{ fontSize: 'h5.fontSize', width: 300 }} />
                        : (
                                <>
                                    <Typography fontWeight='bold' variant='h5'>{primary}</Typography>
                                    {secondary &&
                                        <Typography variant='h6'>&nbsp;|&nbsp;{secondary}</Typography>}
                                </>
                            )}
                </Tile.Row>
                {timeSettings && <TimeSelection />}
                {actions}
            </Tile.Row>
            <Tile.Column>
                {subActions?.map((x, i) => {
                    return (
                        <Typography
                            key={i}
                            className={x.onClick && 'simple-text-link'}
                            variant='body2'
                            onClick={x.onClick}>
                            {x.icon && (
                                <>
                                    <RouteIcon icon={x.icon} />
                                &nbsp;
                                </>
                            )}
                            {x.label}
                        </Typography>
                    )
                })}
            </Tile.Column>
        </Tile.Column>
    )
}

export default RouteHeader
